import {Component, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {NewTaskModalComponent} from '../new-task-modal/new-task-modal.component';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {MyWebDeskService} from "@components/my-web-desk/my-web-desk.service";
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";

@Component({
    selector: 'app-my-web-desk-header',
    templateUrl: './my-web-desk-header.component.html',
    styleUrls: ['./my-web-desk-header.component.css']
})
export class MyWebDeskHeaderComponent implements OnInit, OnDestroy {
    data: any;
    projects = [];

    filteredProjects = [];

    taskType = null;
    deadline = null;

    selectable = true;
    removable = true;

    searchText = '';
    selected = -1;

    showChips = false;


    dateRange = [{
        id: 0,
        name: 'Danas',
        value: 'today',
        checked: false

    },
        {
            id: 1,
            name: 'Sjutra',
            value: 'tomorrow',
            checked: false

        },
        {
            id: 2,
            name: 'Narednih 7 dana',
            value: 'next_7_days',
            checked: false
        },
        {
            id: 3,
            name: 'Narednih mjesec dana',
            value: 'next_30_days',
            checked: false

        }];

    taskTypes = [{
        name: 'Sastanak',
        value: 'meeting',
        checked: true

    },
        {
            name: 'Zadatak',
            value: 'task',
            checked: true

        }];

    filters = {
        title: '',
        projects: this.filteredProjects,
        taskType: this.taskTypes,
        deadline: this.dateRange
    };

    constructor(public matDialog: MatDialog,
                public taskService: TaskService,
                private ren: Renderer2,
                private myWebDeskSrv: MyWebDeskService) {


    }


    async ngOnInit() {
        const fun1 = await this.getProjects();
        this.showChips = true;


    }


    createNewTask() {
        const dialogConfig = new MatDialogConfig();
        const opet = this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                id: 'modal-component',
                mode: 'new'
            }
        });

    }

    ngOnDestroy() {
    }

    getProjects() {
        return new Promise((resolve, reject) => {
            this.taskService.getProjects().subscribe(data => {
                this.projects = data;
                this.projects.push({_id: null, name: 'Nema projekat'});
                this.projects.forEach(item => {
                    item.checked = false;
                });

                this.filteredProjects = this.projects;
                this.filters.projects = this.filteredProjects;
                let userFilters = localStorage.getItem('kanban_filters');

                if (userFilters !== null) {
                    userFilters = JSON.parse(userFilters);
                    this.filters.title = userFilters['title'];
                    if (userFilters['projects'].length > 0) {
                        userFilters['projects'].forEach(item => {
                            let b = this.projects.findIndex(x => x._id === item._id);
                            if (isNotNullOrUndefined(b)) {
                                this.projects[b] = item;
                            }
                        });
                    }


                    if (userFilters['deadline'].length > 0) {
                        let index = this.dateRange.findIndex(x => x.value === userFilters['deadline'][0]['value']);
                        if (isNotNullOrUndefined(index)) {
                            this.dateRange[index] = userFilters['deadline'][0];
                        }
                    }

                    if (userFilters['taskType'].length > 0) {
                        if (userFilters['taskType'].length == 1) {
                            let b = this.taskTypes.findIndex(x => x.value === userFilters['taskType'][0]['value']);
                            this.taskTypes[b] = userFilters['taskType'][0];
                            if (b == 0) {
                                this.taskTypes[1]['checked'] = false;
                            } else {
                                this.taskTypes[0]['checked'] = false;
                            }
                        } else if (userFilters['taskType'].length == 2) {
                            this.taskTypes.forEach(item => {
                                item.checked = userFilters['taskType'][0]['checked'];
                            });
                        }
                    }
                }

                resolve();
            });
        });

    }

    filterProjects(event) {
        if (event.key !== '') {
            this.filteredProjects = this.projects.filter(x => x.name.toLowerCase().includes(this.searchText.toLowerCase()));
        } else {
            this.filteredProjects = this.projects;
        }

    }

    sendDataToKanban() {

        const projects = this.filteredProjects.filter(x => x.checked === true);
        const deadline = this.dateRange.filter(x => x.checked === true);
        const type = this.taskTypes.filter(x => x.checked === true);

        this.filters.projects = projects;
        this.filters.deadline = deadline;
        this.filters.taskType = type;
        localStorage.setItem('kanban_filters', JSON.stringify(this.filters));
        this.myWebDeskSrv.kanbanFilters.next({data: this.filters});


    }

    removeItem(tag, array) {
        const i = array.indexOf(tag);
        if (i !== -1) {
            array[i].checked = false;
            const fun1 = this.sendDataToKanban();
        }


    }

    valueChange(event) {
        if (event.checked === true) {
            this.dateRange[this.selected].checked = event.checked;
            this.dateRange.forEach((item, key) => {
                if (key !== this.selected) {
                    item.checked = !event.checked;
                }
            });
        } else {
            this.dateRange[this.selected].checked = event.checked;
        }


        this.filters.deadline = this.dateRange.filter(x => x.checked === true);
    }

    getCheckedProjects() {
        return this.filteredProjects.filter(x => x.checked === true);
    }

    getCheckedDeadline() {
        return this.filters.deadline.filter(x => x.checked === true);
    }

    getCheckedType() {
        return this.filters.taskType.filter(x => x.checked === true);
    }

    changeKanbanPreviewHandler(type: string) {
        this.myWebDeskSrv.kanbanPreview.next(type);

    }
}
